var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4 col-sm-offset-4"},[_c('h2',[_vm._v("Authentification")]),_vm._v(" "),_c('p',[_vm._v("Veuillez vous authentifier.")]),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"alert alert-danger"},[_c('p',[_vm._v(_vm._s(_vm.error))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-137e6a24","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/admin/Authentification.vue
// module id = null
// module chunks = 